import api from './api';

export const projectService = {
  async getProjects(params = {}) {
    const response = await api.get('/projects', { params });
    return response.data;
  },
  
  async getProject(id) {
    const response = await api.get(`/projects/${id}`);
    return response.data.data;
  },
  
  async createProject(data) {
    const response = await api.post('/projects', data);
    return response.data.data;
  },
  
  async updateProject(id, data) {
    const response = await api.patch(`/projects/${id}`, data);
    return response.data.data;
  },
  
  async deleteProject(id) {
    const response = await api.delete(`/projects/${id}`);
    return response.data;
  },
  
  async archiveProject(id) {
    const response = await api.post(`/projects/${id}/archive`);
    return response.data.data;
  },
  
  async restoreProject(id) {
    const response = await api.post(`/projects/${id}/restore`);
    return response.data.data;
  },
  
  async addMember(id, data) {
    const response = await api.post(`/projects/${id}/members`, data);
    return response.data.data;
  },
  
  async removeMember(projectId, userId) {
    const response = await api.delete(`/projects/${projectId}/members/${userId}`);
    return response.data.data;
  },
  
  async updateMemberRole(projectId, userId, data) {
    const response = await api.patch(`/projects/${projectId}/members/${userId}`, data);
    return response.data.data;
  },
  
  async uploadFile(id, file, category, isClientVisible = false, name = null) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('category', category);
    formData.append('isClientVisible', isClientVisible);
    if (name) {
      formData.append('name', name);
    }
    
    const response = await api.post(`/projects/${id}/files`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data.data;
  },
  
  async deleteFile(projectId, fileId) {
    const response = await api.delete(`/projects/${projectId}/files/${fileId}`);
    return response.data;
  },
  
  async addNote(id, data) {
    const response = await api.post(`/projects/${id}/notes`, data);
    return response.data.data;
  },
  
  async updateNote(projectId, noteId, data) {
    const response = await api.patch(`/projects/${projectId}/notes/${noteId}`, data);
    return response.data.data;
  },
  
  async deleteNote(projectId, noteId) {
    const response = await api.delete(`/projects/${projectId}/notes/${noteId}`);
    return response.data;
  },
  
  async addMilestone(id, data) {
    const response = await api.post(`/projects/${id}/milestones`, data);
    return response.data.data;
  },
  
  async updateMilestone(projectId, milestoneId, data) {
    const response = await api.patch(`/projects/${projectId}/milestones/${milestoneId}`, data);
    return response.data.data;
  },
  
  async deleteMilestone(projectId, milestoneId) {
    const response = await api.delete(`/projects/${projectId}/milestones/${milestoneId}`);
    return response.data;
  },
  
  async getTimeline(id, params = {}) {
    const response = await api.get(`/projects/${id}/timeline`, { params });
    return response.data;
  },
  
  async updateClientAccess(id, data) {
    const response = await api.patch(`/projects/${id}/client-access`, data);
    return response.data.data;
  }
};
